import React from "react";
import { AVATAR_CONFIG } from "../../constants/adminBookingConstants";

/**
 * Admin Avatar Component
 * Displays a circular avatar with the first letter of the admin's name
 * 
 * The avatar uses a green gradient background and displays the first letter
 * of the admin's name in uppercase.
 * 
 * @param {Object} props - Component props
 * @param {string} props.name - Admin name to display
 * @param {string} [props.className] - Additional CSS classes
 */
const AdminAvatar = ({ name, className = "" }) => {
  const initial = name?.charAt(0)?.toUpperCase() || "A";

  return (
    <div
      className={className}
      style={{
        width: AVATAR_CONFIG.SIZE,
        height: AVATAR_CONFIG.SIZE,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #52c41a 0%, #73d13d 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: 600,
        fontSize: AVATAR_CONFIG.FONT_SIZE,
        boxShadow: "0 2px 8px rgba(82, 196, 26, 0.3)",
        flexShrink: 0,
      }}
    >
      {initial}
    </div>
  );
};

export default AdminAvatar;
